module.exports = __webpack_public_path__ + "media/fonts/sovremennic/SovremennicWide-Light-a921ee7b9fcaaf1a9ba1c2de24697001.ttf";